export default __webpack_public_path__ + "static/vision-icon-a581ad8bed30abba89379c27a6a61a64.svg";